import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Module13Team {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.popUpBioClicks = document.querySelectorAll('.module-13_team .click_pop-bio');
      cache.popUpBioClose = document.querySelectorAll('.pop-bio .close');
    };

    let registerEvents = () => {
      for (let i = 0; i < cache.popUpBioClicks.length; i++) {
        cache.popUpBioClicks[i].addEventListener("click", openpopUpBio);
      }
      for (let i = 0; i < cache.popUpBioClose.length; i++) {
        cache.popUpBioClose[i].addEventListener("click", closepopUpBio);
      }
    };

    let openpopUpBio = function() {
      utils.disableScroll();
      const el = this;
      const popUpBio_class = el.dataset.bio;
      const popUpBio = document.querySelector('.'+popUpBio_class);

      popUpBio.style.display = "flex";

      anime({
        targets: popUpBio,
        opacity: [0,1],
        scale: [0.95, 1],
        duration: 400,
        easing: 'easeOutQuad'
      });

    }

    let closepopUpBio = function() {
      const popUpBio = this.closest('.pop-bio');

      anime({
        targets: popUpBio,
        opacity: [1,0],
        scale: [1, 0.95],
        duration: 400,
        delay: 100,
        easing: 'easeOutQuad',
        complete: function() {
          popUpBio.style.display = "none";
          utils.enableScroll();
        }
      });
    }

    initFunc();
  };
}
export { Module13Team }
